<script setup>
import { ref, computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Select an option',
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);

// Affiche le label de l'option sélectionnée ou le placeholder
const displayValue = computed(() => {
  if (!props.modelValue) {
    return props.placeholder;
  }
  const selectedOption = props.options.find(
    opt => opt.value === props.modelValue
  );
  return selectedOption ? selectedOption.label : props.placeholder;
});

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

const handleSelect = value => {
  emit('update:modelValue', value);
  isOpen.value = false;
};
</script>

<template>
  <div class="flex flex-col gap-1.5 w-full">
    <!-- Label du champ -->
    <label v-if="label" class="block text-sm font-medium text-n-slate-12">
      {{ label }}
    </label>

    <!-- Select Menu -->
    <div
      v-on-clickaway="() => (isOpen = false)"
      class="relative flex flex-col gap-1 w-full"
    >
      <Button
        icon="i-lucide-chevron-down"
        size="sm"
        trailing-icon
        color="slate"
        variant="faded"
        class="!w-full !justify-between"
        :class="{ 'dark:!bg-n-alpha-2 !bg-n-slate-9/20': isOpen }"
        :label="displayValue"
        @click="toggleMenu"
      />
      <div
        v-if="isOpen"
        class="absolute select-none w-full min-w-[200px] flex flex-col p-1 rounded-md shadow-xl bg-n-alpha-3/50 backdrop-blur-[100px] outline-1 outline outline-n-weak/50 top-full mt-1 z-40"
      >
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="w-full min-h-7 flex items-center flex-nowrap p-1 rounded-md overflow-hidden text-xs text-n-slate-12 hover:bg-n-brand hover:text-white cursor-pointer"
          :class="{ 'bg-n-brand text-white': option.value === modelValue }"
          @click="handleSelect(option.value)"
        >
          <span class="mx-2 truncate flex-1 text-left">{{ option.label }}</span>
          <span
            v-if="option.value === modelValue"
            class="i-lucide-check size-3.5 flex-shrink-0"
          />
        </button>
      </div>
    </div>
  </div>
</template>
